import { createStandaloneToast, useToast as useChakraToast } from '@chakra-ui/react'
import { AlertStatus } from '@chakra-ui/alert'

const displayToast = (toast: ReturnType<typeof useChakraToast>, message: string, status: AlertStatus, id?: string) => {
  if (id && toast.isActive(id)) {
    return
  }

  toast({
    id,
    status,
    position: 'bottom',
    description: message,
  })
}

export const useToast = () => {
  const toast = useChakraToast()

  return (message: string, status: AlertStatus = 'success', id?: string) => displayToast(toast, message, status, id)
}

export const createToast = (message: string, status: AlertStatus = 'success', id?: string) => {
  const toast = createStandaloneToast()

  displayToast(toast, message, status, id)
}
